module.exports = __webpack_public_path__ + "images/patterns/light/StripeDiagonal.446fede35a641ea6fb60.svg";